module.exports = __webpack_public_path__ + "img/survey_kepuasan.9b62174b.png";